import React from "react";
import { Layout } from "antd";
import "./AdminContainer.css";

const { Content } = Layout;

const AdminContainer = ({ children }) => {
  return (
    <Layout className="admin-container">
      <Content className="admin-content">{children}</Content>
    </Layout>
  );
};

export default AdminContainer;
